import { render } from "./FeedbackStepThree.vue?vue&type=template&id=270fd3eb"
import script from "./FeedbackStepThree.vue?vue&type=script&lang=js"
export * from "./FeedbackStepThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__